import { render, staticRenderFns } from "./mb-home.vue?vue&type=template&id=0fe3a5ad&"
import script from "./mb-home.vue?vue&type=script&lang=js&"
export * from "./mb-home.vue?vue&type=script&lang=js&"
import style0 from "./mb-home.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports